<template>
    <article>
        <section class="row my-1" v-for="(item, index) of arrayOfValues">
            <div class="col-sm-2">
                <label>Value {{ index + 1 }}</label>
            </div>
            <div class="col-sm-8">
                <label>{{ item }}</label>
            </div>
            <div class="col-sm-2">
                <button type="button" class="btn btn-danger border border-dark" @click="removeValue(index)">&times;</button>
            </div>
        </section>

        <section class="row my-3">
            <label class="col-sm-2 col-form-label">Add value</label>
            <div class="col-sm-8">
            <input type="text" class="form-control border border-dark" v-model.trim="newValue" />
            </div>
            <div class="col-sm-2">
                <button type="button" class="btn btn-primary border border-dark" @click="addValue()">+</button>
            </div>
        </section>

        <input type="hidden" name="valuesList" :value="arrayOfValues">
    </article>
</template>

<script>
export default {
    props : {

        preDefined : {
            type : Array,
            default : () => { return []; }
        }

    },

    data() {
        return {
            arrayOfValues : this.preDefined.splice(0),
            newValue : ""
        };
    },

    methods : {

        addValue(){
            if (this.newValue.length > 0){
                if (this.arrayOfValues.indexOf(this.newValue) < 0) this.arrayOfValues.push(this.newValue);
            }
        },

        removeValue(index){
            if (index >= 0 && index < this.arrayOfValues.length) this.arrayOfValues.splice(index, 1);
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/common/MeasurementListEditor.vue